import { PropsWithChildren } from "react";

import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";

import { useBaikiTheme } from "@/theme";

export const AppThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useBaikiTheme();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
